import { Box, IconButton } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { ExternalLinkIcon } from "../Icons";
import { palette } from "../../theme/palette";

const useStyles = makeStyles(() => ({
  headUsername: {
    color: palette.typography.white.solid,
    cursor: "default",
    fontSize: "0.75rem",
    lineHeight: "1rem",
    marginRight: "0.25rem",
  },
  menu: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
  },
}));

export const AppMenuButton = ({ onClick, setAnchorEl }) => {
  const styles = useStyles();

  return (
    <Box className={styles.menu}>
      <IconButton onClick={onClick} data-testid="app-menu-button" size="large">
        <Box ref={setAnchorEl}>
          <ExternalLinkIcon />
        </Box>
      </IconButton>
    </Box>
  );
};
